import { isIOS, isSafari } from './mobile';

const documentBody = document.body;
const noScrollClass = 'pk-body--no-scroll';
const noScrollClassIos = `${noScrollClass}--ios`;

export const blockScroll = (block: boolean, suffix: string) => {
  const wasBlocked = documentBody.classList.contains(noScrollClass);
  documentBody.classList.toggle(`${noScrollClass}--${suffix}`, block);

  const isBlocked = Array.from(documentBody.classList).some(
    (c) => c !== noScrollClassIos && c.includes(`${noScrollClass}--`),
  );
  documentBody.classList.toggle(noScrollClass, isBlocked);

  if (!isIOS() && !isSafari()) return;

  if (isBlocked) {
    const scrollY = window.scrollY;
    documentBody.style.setProperty('top', `-${scrollY}px`);
    documentBody.classList.add(noScrollClassIos);
  } else if (wasBlocked) {
    const scrollY = parseInt(documentBody.style.top || '0') * -1;
    documentBody.classList.remove(noScrollClassIos);
    documentBody.style.removeProperty('top');
    scrollY && window.scrollTo(0, scrollY);
  }
};
